import React from 'react'
import { NoteSidebar } from '@sukiai/components'
import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE } from '../lib/constants'

// Utils
import {
  isAmwellTheme
} from '../lib'

const SidebarContainer = (props) => {
  const isSmallWindow = isAmwellTheme() || useMediaQuery({
    query: `(max-width: ${RESPONSIVE.CLOSE_SIDEBAR_WIDTH})`
  })
  return (!isSmallWindow &&
    <NoteSidebar
      modalType={props.modalType}
      setCurrentSection={props.setCurrentSection}
      currentSectionId={props.currentSectionId}
      initialSections={props.initialSections}
      sectionsToUpdate={props.sectionsToUpdate}
      patient={props.patient}
    />
  )
}

export default SidebarContainer
